import { Component } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

import {EventsService} from '../../../../services/events/events.service';

@Component({
  selector: 'modal-message-ok',
  styleUrls: [('./modalMessageOk.scss')],
  templateUrl: './modalMessageOk.html'
})

export class ModalMessageOk {
    header: string = '';
    message: string = '';

  constructor(
    private _activeModal: NgbActiveModal, 
    private _eventsService: EventsService
  ) {

  }

  ngOnInit() {}

  closeModal() {
    this._activeModal.close();
  }

}



// WEBPACK FOOTER //
// /app/src/app/theme/components/modals/components/modalMessageOk/modalMessageOk.component.ts